import { LabFormData } from 'models/forms';
import { DEFAULT_LOCALE_FORMAT } from 'models/locale-format';

export const emptyLabFormData = () => {
    return {
        hitHorizonsId: '',
        name: '',
        officialName: '',
        organizationNumber: '',
        active: true,
        address: {
            street: '',
            postalCode: '',
            city: '',
            country: '',
        },
        phone: '',
        email: '',
        site: '',
        vatNo: '',
        crediflowPartyId: undefined,
        localeFormat: DEFAULT_LOCALE_FORMAT,
    } as LabFormData;
};
